module.exports = __webpack_public_path__ + "img/beeldschermbril-evolutie.f2b293ed.svg";